/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { fileModelSchema } from "./fileModelSchema.ts";
import { z } from "zod";

export const presignedUrlModelSchema = z.object({
    "fileInfo": z.lazy(() => fileModelSchema).describe("Метаданные файла"),
"presignedUrl": z.string().describe("Подписанный URL")
    })